import React, {useEffect, useState} from "react";
import enterpriseObjectClassFactory from "../../eoec/EnterpriseObjectClassFactory";
import EnterpriseObject from "../../eoec/eo/EnterpriseObject";
import EnterpriseComponent from "../../eoec/ec/EnterpriseComponent";
import {prepareBuffer} from "../../util/Buffer";
import EventBus from "../../util/EventBus";
import {Button, Chip, Drawer, IconButton, MenuItem, TextField, Tooltip, Typography} from "@mui/material";
import css_buttons from "../Common/css/CCButton.module.scss";
import css_typography from "../Common/css/Typography.module.scss";
import {AddCircle, Close, Edit, Info} from "@mui/icons-material";
import {Grey5, Grey6} from "../../theme/styles";
import ProjectPlanPhaseMilestoneReferenceTableApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneReferenceTableApplet";
import {formatDate} from "../../util/Formatters";
import ProjectPlanPhaseMilestoneFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneFormApplet";
import {hasPrivilege} from "../../util/SessionContext";
import ProjectPlanPhaseMilestoneReferenceFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneReferenceFormApplet";
import ProjectPlanPhaseMilestoneEmployeeTableApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneEmployeeTableApplet";
import ProjectPlanPhaseMilestoneEmployeeFormApplet from "../../eoec/applet/impl/ProjectPlan/ProjectPlanPhaseMilestoneEmployeeFormApplet";


export default function ProjectPlanPhaseMilestoneDetail(props: any) {
    const [projectPlanPhaseMilestoneEnterpriseObject] = useState<EnterpriseObject>(() => enterpriseObjectClassFactory("ProjectPlanPhaseMilestone") as EnterpriseObject);
    const [projectPlanPhaseMilestoneBuffer, setProjectPlanPhaseMilestoneBuffer] = React.useState<Map<string, any>>(new Map<string, any>());
    const [showEditPanelForMilestone, setShowEditPanelForMilestone] = React.useState(false);
    const [showAddReference, setShowAddReference] = React.useState(false);
    const [showAddEmployee, setShowAddEmployee] = React.useState(false);
    const [currentProjectPlanPhaseUSID, setCurrentProjectPlanPhaseUSID] = React.useState<string>(props.projectPlanPhaseUSID);
    const [currentProjectPlanPhaseMilestoneUSID, setCurrentProjectPlanPhaseMilestoneUSID] = React.useState<string>(props.projectPlanPhaseMilestoneUSID);

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec)
        setProjectPlanPhaseMilestoneBuffer(b[0]);
    }

    function enterpriseComponentValueChanged(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        setProjectPlanPhaseMilestoneBuffer(b[0]);
    }

    function enterpriseComponentUpdateRollbackCompleted(ec: EnterpriseComponent) {
        let b:Map<string, any>[] = prepareBuffer(ec);
        b = b.slice(ec.getRecordPointer(), ec.getRecordPointer() + 1);
        setProjectPlanPhaseMilestoneBuffer(b[0]);
    }

    useEffect(() => {
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanPhaseMilestoneEnterpriseObject.getEnterpriseComponent("ProjectPlanPhaseMilestone")!

        EventBus.components.addListener("project-plan-phase-milestone-reference-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-reference-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-employee-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-employee-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-attachment-form-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-attachment-form-applet-save", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-form-edit-applet-cancel", onCancelHandler);
        EventBus.components.addListener("project-plan-phase-milestone-form-edit-applet-save", onCancelHandler);

        projectPlanPhaseMilestoneEnterpriseComponent.newQuery();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", currentProjectPlanPhaseMilestoneUSID);
        projectPlanPhaseMilestoneEnterpriseComponent.setIDOCRequest("v1.ProjectPlanPhaseMilestone-001");
        projectPlanPhaseMilestoneEnterpriseComponent.setIDOCResponse("v1.ProjectPlanPhaseMilestone-001");
        projectPlanPhaseMilestoneEnterpriseComponent.executeQuery(1, 5);

        projectPlanPhaseMilestoneEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        projectPlanPhaseMilestoneEnterpriseComponent.addValueChangedListener(enterpriseComponentValueChanged);
        projectPlanPhaseMilestoneEnterpriseComponent.addUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);

        return () => {
            EventBus.components.removeListener("project-plan-phase-milestone-form-edit-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-form-edit-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-employee-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-employee-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-attachment-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-attachment-form-applet-save", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-reference-form-applet-cancel", onCancelHandler);
            EventBus.components.removeListener("project-plan-phase-milestone-reference-form-applet-save", onCancelHandler);

            projectPlanPhaseMilestoneEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
            projectPlanPhaseMilestoneEnterpriseComponent.removeValueChangedListener(enterpriseComponentValueChanged);
            projectPlanPhaseMilestoneEnterpriseComponent.removeUpdateRollbackCompletedListener(enterpriseComponentUpdateRollbackCompleted);
        }

    }, [projectPlanPhaseMilestoneEnterpriseObject, currentProjectPlanPhaseMilestoneUSID]);

    function onCancelHandler() {
        setShowEditPanelForMilestone(false);
        setShowAddReference(false);
        setShowAddEmployee(false);
    }

    function setPhaseSelector(value: string) {
        setCurrentProjectPlanPhaseUSID(value);
    }

    function setMilestoneSelector(value: string) {
        const projectPlanPhaseMilestoneEnterpriseComponent: EnterpriseComponent = projectPlanPhaseMilestoneEnterpriseObject!.getEnterpriseComponent("ProjectPlanPhaseMilestone")!

        projectPlanPhaseMilestoneEnterpriseComponent.newQuery();
        projectPlanPhaseMilestoneEnterpriseComponent.setAttributeValue("USID", value);
        projectPlanPhaseMilestoneEnterpriseComponent.executeQuery(1, 5);

        setCurrentProjectPlanPhaseMilestoneUSID(value);
    }

    function getPhaseMilestoneEditTooltip() {
        if (projectPlanPhaseMilestoneBuffer.get("ProjectPlanPhaseStatus") === "DONE") {
            return "This feature is disabled because the status of the Phase is 'DONE'.";
        }
        if (!hasPrivilege("Edit Milestone", props.projectPlanBuffer.get("USID"))) {
            return "This feature is disabled because you do not have the 'Edit Milestone' privilege in any of your assigned roles."
        }
    }

    function getAddReferenceTooltip() {
        if (projectPlanPhaseMilestoneBuffer.get("ProjectPlanPhaseStatus") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE") {
            return "This feature is not available because the status of the milestone is 'DONE'"
        }
        if (!hasPrivilege("Add Milestone Reference", props.projectPlanBuffer.get("USID"))) {
            return "This feature is disabled because you do not have the 'Add Milestone Reference' privilege in any of your assigned roles."
        }
    }

    function getAddAssigneeTooltip() {
        if (projectPlanPhaseMilestoneBuffer.get("ProjectPlanPhaseStatus") === "DONE") {
            return "This feature is not available because the status of the phase is 'DONE'"
        }
        if (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE") {
            return "This feature is not available because the status of the milestone is 'DONE'"
        }
        if (!hasPrivilege("Add Milestone Assignee", props.projectPlanBuffer.get("USID"))) {
            return "This feature is disabled because you do not have the 'Add Milestone Assignee' privilege in any of your assigned roles."
        }
    }

    function phaseMilestoneDetailView() {
        let projectPlanPhaseMilestoneReferenceEnterpriseComponent: EnterpriseComponent | null = null;
        let projectPlanPhaseMilestoneEmployeeEnterpriseComponent: EnterpriseComponent | null = null;
        if (projectPlanPhaseMilestoneEnterpriseObject !== null) {
            projectPlanPhaseMilestoneReferenceEnterpriseComponent = projectPlanPhaseMilestoneEnterpriseObject!.getEnterpriseComponent("ProjectPlanPhaseMilestoneReference")!
            projectPlanPhaseMilestoneEmployeeEnterpriseComponent = projectPlanPhaseMilestoneEnterpriseObject!.getEnterpriseComponent("ProjectPlanPhaseMilestoneEmployee")!
        }
        const currentPhase = props.projectPlanBuffer.get("ProjectPlanPhases").find((element: any) => element.USID === currentProjectPlanPhaseUSID);

        return (
            <>
                {showEditPanelForMilestone ? <ProjectPlanPhaseMilestoneFormApplet enterpriseComponent={projectPlanPhaseMilestoneEnterpriseObject!.getEnterpriseComponent("ProjectPlanPhaseMilestone")} defaultAction={"Edit"}/> : null}
                {showAddReference ? <ProjectPlanPhaseMilestoneReferenceFormApplet enterpriseComponent={projectPlanPhaseMilestoneReferenceEnterpriseComponent} defaultAction="New"/> : null}
                {showAddEmployee ? <ProjectPlanPhaseMilestoneEmployeeFormApplet enterpriseComponent={projectPlanPhaseMilestoneEmployeeEnterpriseComponent} defaultAction="New"/> : null}
                <Drawer anchor={"right"} open={true}>
                    <div style={{width: "1050px"}}>
                        <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "40px"}}>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start"}}>
                                    <div style={{width: "275px"}}>
                                        <TextField select={true}
                                                   fullWidth={true}
                                                   size="small"
                                                   label={"Phase"}
                                                   value={currentProjectPlanPhaseUSID}
                                                   onChange={(e) => setPhaseSelector(e.target.value)}
                                                   variant="outlined"
                                                   slotProps={{
                                                       input: {

                                                       },
                                                       inputLabel: {
                                                           shrink: true
                                                       }
                                                   }}>
                                            {props.projectPlanBuffer.get("ProjectPlanPhases").map((phase: any) => (
                                                <MenuItem value={phase["USID"]}>{phase["Name"]}</MenuItem>
                                            ))}

                                        </TextField>
                                    </div>
                                    <div style={{marginLeft: "30px", width: "275px"}}>
                                        <TextField select={true}
                                                   fullWidth={true}
                                                   size="small"
                                                   label={"Milestone"}
                                                   value={currentProjectPlanPhaseMilestoneUSID}
                                                   onChange={(e) => setMilestoneSelector(e.target.value)}
                                                   variant="outlined"
                                                   slotProps={{
                                                       input: {

                                                       },
                                                       inputLabel: {
                                                           shrink: true
                                                       }
                                                   }}>
                                            {currentPhase["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"].map((milestone: any) => (
                                                <MenuItem value={milestone["USID"]}>{milestone["Name"]}</MenuItem>
                                            ))}

                                        </TextField>
                                    </div>

                                </div>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end"}}>
                                    <IconButton className={css_buttons.blueIconButton} style={{marginLeft: "5px"}} onClick={() => {
                                        EventBus.components.emit("project-plan-phase-milestone-panel-close");
                                    }}>
                                        <Close sx={{color: Grey5, width: "35px", height: "35px"}}/>
                                    </IconButton>
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px"}}>
                                <Typography style={{fontSize: "24px", fontWeight: 600, color: "#000000"}}>Milestone:&nbsp;</Typography>
                                <Typography style={{fontSize: "24px", fontWeight: "600", color: "#A8A9AF", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>&nbsp;{projectPlanPhaseMilestoneBuffer.get("Name")}</Typography>
                                {projectPlanPhaseMilestoneBuffer.get("Status") !== null ? (
                                    <div style={{paddingLeft: "15px", paddingTop: "3px", paddingRight: "7px"}}>
                                        <Chip label={projectPlanPhaseMilestoneBuffer.get("Status")} size="small" style={{border: "1px solid #519849", fontSize: 12, marginTop: "3px", backgroundColor: "#E6FCD9", color: "#519849"}}/>
                                    </div>
                                ) : (
                                    <div style={{paddingTop: "3px"}}>
                                        &nbsp;
                                    </div>
                                )}
                                <div>
                                    <Tooltip title={"Edit Milestone"}>
                                        <IconButton className={css_buttons.blueIconButton} disabled={!(hasPrivilege("Edit Milestone", props.projectPlanBuffer.get("USID")) && (projectPlanPhaseMilestoneBuffer.get("ProjectPlanPhaseStatus") !== "DONE"))} style={{marginLeft: "0px"}} onClick={() => {
                                            setShowEditPanelForMilestone(true);
                                        }}>
                                            <Edit sx={{width: "20px", height: "20px", marginTop: "2px"}}/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                {(!hasPrivilege("Edit Milestone", props.projectPlanBuffer.get("USID")) || projectPlanPhaseMilestoneBuffer.get("ProjectPlanPhaseStatus") === "DONE") ? (
                                    <div style={{marginTop: "6px"}}>
                                        <Tooltip title={getPhaseMilestoneEditTooltip()}>
                                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                        </Tooltip>
                                    </div>
                                ) : null}
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "10px"}}>
                                <Typography style={{fontSize: 17, fontWeight: 400, color: Grey6}}>{projectPlanPhaseMilestoneBuffer.get("Description")}</Typography>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "10px", borderBottom: "2px solid #EDEFF3"}}/>
                            <div style={{width: "100%", padding: "10px"}}>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                    <div style={{width: "100px"}}>
                                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Name:</Typography>
                                    </div>
                                    <div style={{width: "400px"}}>
                                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{projectPlanPhaseMilestoneBuffer.get("Name") ?? "--"}</Typography>
                                    </div>
                                </div>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                    <div style={{width: "100px"}}>
                                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Start Date:</Typography>
                                    </div>
                                    <div style={{width: "400px"}}>
                                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{formatDate(projectPlanPhaseMilestoneBuffer.get("StartDatetime")) ?? "--"}</Typography>
                                    </div>
                                </div>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                    <div style={{width: "100px"}}>
                                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Due Date:</Typography>
                                    </div>
                                    <div style={{width: "400px"}}>
                                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{formatDate(projectPlanPhaseMilestoneBuffer.get("DueDatetime")) ?? "--"}</Typography>
                                    </div>
                                </div>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                    <div style={{width: "100px"}}>
                                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Status:</Typography>
                                    </div>
                                    <div style={{width: "400px"}}>
                                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{projectPlanPhaseMilestoneBuffer.get("Status") ?? "--"}</Typography>
                                    </div>
                                </div>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", width: "100%"}}>
                                    <div style={{width: "100px"}}>
                                        <Typography className={css_typography.DetailLabel} style={{marginBottom: 3}}>Notes:</Typography>
                                    </div>
                                    <div style={{width: "400px"}}>
                                        <Typography className={css_typography.DetailData} style={{marginLeft: "10px"}}>{projectPlanPhaseMilestoneBuffer.get("Notes") ?? "--"}</Typography>
                                    </div>
                                </div>
                            </div>

                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: "20px"}}>
                                <Button
                                    className={css_buttons.blueStandardButton} style={{width: "165px", cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small"
                                    disabled={!hasPrivilege("Add Milestone Reference", props.projectPlanBuffer.get("USID")) || (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE")}
                                    onClick={() => {
                                        let picklist = projectPlanPhaseMilestoneReferenceEnterpriseComponent!.getAttribute("ParentUSID").getPicklist();
                                        picklist?.setSearchSpecification({
                                            "ProjectPlanPhaseMilestoneUSID": projectPlanPhaseMilestoneBuffer.get("USID")
                                        })
                                        setShowAddReference(true);
                                    }}
                                    startIcon={<AddCircle sx={{color: "#FFFFFF", width: "30px", height: "30px"}}/>}>
                                    Add Reference
                                </Button>
                                {!hasPrivilege("Add Milestone Reference", props.projectPlanBuffer.get("USID")) || (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE") ? (
                                    <div style={{marginLeft: "2px", marginTop: "5px"}}>
                                        <Tooltip title={getAddReferenceTooltip()}>
                                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                        </Tooltip>
                                    </div>
                                ) : null}
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px"}}>
                                <ProjectPlanPhaseMilestoneReferenceTableApplet enterpriseComponent={projectPlanPhaseMilestoneReferenceEnterpriseComponent}/>
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: "20px"}}>
                                <Button
                                    className={css_buttons.blueStandardButton} style={{width: "165px", cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small"
                                    disabled={!hasPrivilege("Add Milestone Assignee", props.projectPlanBuffer.get("USID")) || (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE")}
                                    onClick={() => {
                                        setShowAddEmployee(true);
                                    }}
                                    startIcon={<AddCircle sx={{color: "#FFFFFF", width: "30px", height: "30px"}}/>}>
                                    Add Assignee
                                </Button>
                                {!hasPrivilege("Add Milestone Assignee", props.projectPlanBuffer.get("USID")) || (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE")? (
                                    <div style={{marginLeft: "2px", marginTop: "5px"}}>
                                        <Tooltip title={getAddAssigneeTooltip()}>
                                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                        </Tooltip>
                                    </div>
                                ) : null}
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px"}}>
                                <ProjectPlanPhaseMilestoneEmployeeTableApplet enterpriseComponent={projectPlanPhaseMilestoneEmployeeEnterpriseComponent}/>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </>
        )
    }

    /*
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: "20px"}}>
                                <Button
                                    className={css_buttons.blueStandardButton} style={{width: "185px", cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small"
                                    disabled={!hasPrivilege("Add Milestone_ATTACHMENT", props.projectPlanBuffer.get("USID")) || (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE")}
                                    onClick={() => {
                                        setShowAddAttachment(true);
                                    }}
                                    startIcon={<AddCircle sx={{color: "#FFFFFF", width: "30px", height: "30px"}}/>}>
                                    Upload Attachment
                                </Button>
                                {!hasPrivilege("Add Milestone_ATTACHMENT", props.projectPlanBuffer.get("USID")) || (projectPlanPhaseMilestoneBuffer.get("Status") === "DONE") ? (
                                    <div style={{marginLeft: "2px", marginTop: "5px"}}>
                                        <Tooltip title={getAddAttachmentTooltip()}>
                                            <Info sx={{color: "#F1C40F", width: "25px", height: "25px"}}/>
                                        </Tooltip>
                                    </div>
                                ) : null}
                            </div>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px"}}>
                                <ProjectPlanPhaseMilestoneAttachmentTableApplet enterpriseComponent={projectPlanPhaseMilestoneAttachmentEnterpriseComponent}/>
                            </div>

     */
    return (
        <>
            {phaseMilestoneDetailView()}
        </>
    )
}
